import { differenceInCalendarDays } from 'date-fns'

export type TrialEndingSoonKind = 'twoDays' | 'oneDay'

const trialCalendarDaysRemaining = (
  freeTrialEndDate: string | null | undefined,
  now: Date
): number | null => {
  if (freeTrialEndDate == null) { return null }
  const end = new Date(freeTrialEndDate)
  if (Number.isNaN(end.getTime())) { return null }
  if (end <= now) { return null }
  return differenceInCalendarDays(end, now)
}

/** When trial ends in under 3 local calendar days: 2 days left vs under 2 days (copy for urgency UI). */
export const getTrialEndingSoonKind = (
  freeTrialEndDate: string | null | undefined,
  now: Date = new Date()
): TrialEndingSoonKind | null => {
  const diff = trialCalendarDaysRemaining(freeTrialEndDate, now)
  if (diff == null || diff >= 3) { return null }
  return diff >= 2 ? 'twoDays' : 'oneDay'
}
